import { Injectable } from '@angular/core';

import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Injectable()
export class MetadataService {
	constructor(private db: AngularFireDatabase, private auth: AngularFireAuth) {}

	hydrate(): Observable<any> {
		return this.auth.user.pipe(
			switchMap(u =>
				this.db
					.object(`/user/${u.uid}/metadata`)
					.snapshotChanges()
					.pipe(map(x => x.payload.val()))
			)
		);
	}
}
